import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { Tag } from '@offerzen/pinata'
import SectionHeading from '../SectionHeading'
import styles, { highlightTheme } from './styles'

const Skill = ({ className, skills, otherSkills, filteredSkills, theme }) => {
  const displayedNumOfSkills = 6
  const hasMoreSkills = otherSkills > 0
  const skillsWithFilter = []
  skills.map(skill => {
    skillsWithFilter.push({
      name: skill,
      matchesFilter: filteredSkills?.some(filterSkill => filterSkill.name === skill),
    })
  })

  return (
    <div className={className}>
      <SectionHeading title="Skills" />
      {skillsWithFilter.slice(0, displayedNumOfSkills).map(skill => (
        <Tag key={skill} className={cx(styles.defaultTag, skill.matchesFilter && highlightTheme())} text={skill.name} size="default" />
      ))}
      {hasMoreSkills && <span className={styles.moreText}>+ {otherSkills} more</span>}
      <div className={styles.hiddenInfo}>
        <div className={styles.hiddenInfoText}>Get full access to view career goals, visa and education.</div>
      </div>
    </div>
  )
}
Skill.propTypes = {
  className: PropTypes.string,
  skills: PropTypes.arrayOf(PropTypes.string),
  otherSkills: PropTypes.number,
  filteredSkills: PropTypes.array,
  theme: PropTypes.string,
}
export default Skill
